module.exports = __webpack_public_path__ + "img/not_signed.65ec997d.png";